const HOME = '/'
const LOGIN = '/login'
const LED_SCREEN = '/led-screen'
const FORGOT_PASSWORD = '/forgot-password'
const RESET_PASSWORD = '/reset-password'
const USERS = '/users'
const SIGNUP = '/register'
const VEHICLES = '/vehicles'
const VEHICLESDETAILS = '/vehicles-details'
const DEVICES = '/devices'
const REPORTS = '/reports'
const MAP = '/maps'
const SETTINGS = '/settings'
const ORGANIZATION = '/organization'
const PEOPLE_COUNTER = '/people-counter'
const TELTONIKA_INSTRUCTION = '/teltonika-instruction'
const VALIDATOR = '/validator'
const PANEL = '/panel-screen'
const GEOFENCING = '/geo-fencing'
const PRIVACY_POLICY = '/privacy-policy'
const MOBILITY_PRIVACY_POLICY = '/mobility-privacy-policy'
const VIDEO_STREAMING = '/video'
const PARKING = '/parking'
const CAMERA_MAPPING = '/camera-mapping'
const PARKING_QR = '/parking/qr'
const PARKING_AVAILABILITY = '/parking-availability'
const MANAGE_PARKING_LOTS = '/manage-parking-lots'
const PARKING_SLOTS = '/parking-slots'
const GTFS = '/gtfs'
const GTFS_DETAILS = '/gtfs-details'
const ROUTE_FORECAST = '/route-forecast'
const ROUTE_HISTORY = '/route-history'

export default {
    ROUTE_HISTORY,
    HOME,
    LOGIN,
    SIGNUP,
    USERS,
    VEHICLES,
    DEVICES,
    REPORTS,
    MAP,
    SETTINGS,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    VEHICLESDETAILS,
    ORGANIZATION,
    PEOPLE_COUNTER,
    TELTONIKA_INSTRUCTION,
    VALIDATOR,
    LED_SCREEN,
    PANEL,
    GEOFENCING,
    PRIVACY_POLICY,
    VIDEO_STREAMING,
    MOBILITY_PRIVACY_POLICY,
    PARKING,
    CAMERA_MAPPING,
    PARKING_QR,
    PARKING_AVAILABILITY,
    MANAGE_PARKING_LOTS,
    PARKING_SLOTS,
    GTFS,
    GTFS_DETAILS,
    ROUTE_FORECAST
}